import { on } from '@landing/official-desktop/utils'
import Toast from '@landing/official-desktop/models/Toast'

const toast = new Toast()

on(window, 'offline', () => toast.show('你的網路現在是離線狀態'))
on(window, 'online', () => toast.hide())
